// ============================================
// gsap scrollTrigger
// ============================================
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import Lenis from "lenis";


// ============================================
// 文字のフェード(左から右)
// ============================================
function textFadeLeft() {
	gsap.utils.toArray('.js-fadeLeft').forEach((target) => {
		gsap.to(target, {
			scrollTrigger: {
				trigger: target,
				start: () => 'top 90%',
				end: 'bottom 90%',
				toggleClass: {
					targets: target,
					className: 'is-active',
				},
				once: true,
			},
		});
	});
}

// ============================================
// 文字のフェード(右から左)
// ============================================
function textFadeRight() {
	gsap.utils.toArray('.js-fadeRight').forEach((target) => {
		gsap.to(target, {
			scrollTrigger: {
				trigger: target,
				start: () => 'top 90%',
				end: 'bottom 90%',
				toggleClass: {
					targets: target,
					className: 'is-active',
				},
				once: true,
			},
		});
	});
}

// ============================================
// 文字のフェード(top mv)
// ============================================
function textFadeMv() {
	gsap.utils.toArray('.js-fadeMv').forEach((target) => {
		gsap.to(target, {
			scrollTrigger: {
				trigger: target,
				start: () => 'top 20%',
				end: 'bottom 0%',
				toggleClass: {
					targets: target,
					className: 'is-active',
				},
			},
		});
	});
}

// ============================================
// top MV follow
// ============================================
function mvFollow() {
	const follow = document.querySelector('.js-mv-follow');
	if (follow) {
		const followItem = document.querySelectorAll('.js-mv-follow__item');
		followItem.forEach(function (followItem) {
			ScrollTrigger.create({
				pin: true,
				trigger: followItem,
				endTrigger: '.js-mv-follow__area',
				start: 'top 0%',
				end: 'bottom 100%',
			});
		});
	}
}

// ============================================
// top MV smooth
// ============================================
function mvSmooth() {
	const smooth = document.querySelector('.js-smooth');
	if (smooth) {
		const lenis = new Lenis({
			duration: 1.5,
		})
		lenis.on('scroll', ScrollTrigger.update)
		gsap.ticker.add((time)=>{
			lenis.raf(time * 1000)
		})
	}
}

// ============================================
// export
// ============================================
export { textFadeLeft , textFadeRight , textFadeMv , mvFollow , mvSmooth };